const TZ = [
  {
    id: 'UTC',
    title: 'UTC'
  },
  {
    id: 'Europe/Kaliningrad',
    title: 'Калининград'
  },
  {
    id: 'Europe/Moscow',
    title: 'Москва'
  },
  {
    id: 'Europe/Samara',
    title: 'Самара, Волгоград, Астрахань'
  },
  {
    id: 'Asia/Yekaterinburg',
    title: 'Екатеринбург'
  },
  {
    id: 'Asia/Omsk',
    title: 'Омск'
  },
  {
    id: 'Asia/Novosibirsk',
    title: 'Новосибирск'
  },
  {
    id: 'Asia/Irkutstk',
    title: 'Иркутск'
  },
  {
    id: 'Asia/Yakutsk',
    title: 'Якутск'
  },
  {
    id: 'Asia/Vladivostok',
    title: 'Владивосток'
  },
  {
    id: 'Asia/Magadan',
    title: 'Магадан'
  },
  {
    id: 'Asia/Kamchatka',
    title: 'Камчатка'
  }
]

export default TZ

export const TZ_OFFSETS = {
    "UTC": 0,
    "Europe/Kaliningrad": 2,
    "Europe/Moscow": 3,
    "Europe/Samara": 4,
    "Asia/Yekaterinburg": 5,
    "Asia/Omsk": 6,
    "Asia/Novosibirsk": 7,
    "Asia/Irkutstk": 8,
    "Asia/Yakutsk": 9,
    "Asia/Vladivostok": 10,
    "Asia/Magadan": 11,
    "Asia/Kamchatka": 12
}
 

